/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagingDtoFromJSON, PagingDtoToJSON, } from './PagingDto';
/**
 * @export
 */
export const RptOpportunitySearchDtoStatiEnum = {
    ClosedLost: 'CLOSED_LOST',
    Discovery: 'DISCOVERY',
    MilestonePlanning: 'MILESTONE_PLANNING',
    NegotiationReview: 'NEGOTIATION_REVIEW',
    ProposalPriceQuote: 'PROPOSAL_PRICE_QUOTE',
    Prospecting: 'PROSPECTING',
    Qualification: 'QUALIFICATION'
};
/**
 * @export
 */
export const RptOpportunitySearchDtoSortByEnum = {
    DataPotenzialeAvvio: 'DATA_POTENZIALE_AVVIO',
    OppPercProb: 'OPP_PERC_PROB',
    OppImportoAnno: 'OPP_IMPORTO_ANNO',
    OppImporto: 'OPP_IMPORTO',
    OppNumAttivitaInAgenda: 'OPP_NUM_ATTIVITA_IN_AGENDA'
};
/**
 * @export
 */
export const RptOpportunitySearchDtoSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Check if a given object implements the RptOpportunitySearchDto interface.
 */
export function instanceOfRptOpportunitySearchDto(value) {
    return true;
}
export function RptOpportunitySearchDtoFromJSON(json) {
    return RptOpportunitySearchDtoFromJSONTyped(json, false);
}
export function RptOpportunitySearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fkCliente': json['fkCliente'] == null ? undefined : json['fkCliente'],
        'denominazioneCliente': json['denominazioneCliente'] == null ? undefined : json['denominazioneCliente'],
        'fkStrutturaBusiness': json['fkStrutturaBusiness'] == null ? undefined : json['fkStrutturaBusiness'],
        'denominazioneOpportunity': json['denominazioneOpportunity'] == null ? undefined : json['denominazioneOpportunity'],
        'percProbMin': json['percProbMin'] == null ? undefined : json['percProbMin'],
        'percProbMax': json['percProbMax'] == null ? undefined : json['percProbMax'],
        'dataPotenzialeAvvioDa': json['dataPotenzialeAvvioDa'] == null ? undefined : (new Date(json['dataPotenzialeAvvioDa'])),
        'dataPotenzialeAvvioA': json['dataPotenzialeAvvioA'] == null ? undefined : (new Date(json['dataPotenzialeAvvioA'])),
        'stati': json['stati'] == null ? undefined : json['stati'],
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
        'paging': json['paging'] == null ? undefined : PagingDtoFromJSON(json['paging']),
    };
}
export function RptOpportunitySearchDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fkCliente': value['fkCliente'],
        'denominazioneCliente': value['denominazioneCliente'],
        'fkStrutturaBusiness': value['fkStrutturaBusiness'],
        'denominazioneOpportunity': value['denominazioneOpportunity'],
        'percProbMin': value['percProbMin'],
        'percProbMax': value['percProbMax'],
        'dataPotenzialeAvvioDa': value['dataPotenzialeAvvioDa'] == null ? undefined : ((value['dataPotenzialeAvvioDa']).toISOString().substring(0, 10)),
        'dataPotenzialeAvvioA': value['dataPotenzialeAvvioA'] == null ? undefined : ((value['dataPotenzialeAvvioA']).toISOString().substring(0, 10)),
        'stati': value['stati'],
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString().substring(0, 10)),
        'sortBy': value['sortBy'],
        'sortDirection': value['sortDirection'],
        'paging': PagingDtoToJSON(value['paging']),
    };
}
